/**
 * Main application entry point.
 */

'use strict';

var app = require('mag-app');


app.once('load', function () {
    var geo = require('./modules/geo');

    app.userStore = core.state || null;

    require('spa-gettext').load({name: core.environment.language}, function () {
        app.pages = {
            main: require('./pages/main')
        };

        geo.load({}, function ( data ) {
            app.route(app.pages.main, {
                currentLocation: data
            });
            app.ready();
        });
    });
});
